import { CheckCircle2, Download, FileDown } from "lucide-react";
import { API } from "../../lib/api";

export const QuoteSuccess = ({ product, close, catalogUrl }) => (
  <div className="success-state" data-testid="quote-success">
    <div className="success-icon"><CheckCircle2 /></div>
    <p className="eyebrow">Request received</p>
    <h2>We’re on it.</h2>
    <p>Our technical sales team will call you within 24 hours. A confirmation is on its way to your inbox.</p>
    <div className="success-actions">
      {product && <a className="button button-navy" href={`${API}/products/${product.slug}/spec-sheet.pdf`} data-testid="success-spec-download"><FileDown size={17} /> {product.name} spec sheet</a>}
      <a className="button button-orange" href={catalogUrl} download data-testid="catalog-download-button"><Download size={17} /> Download product catalog</a>
    </div>
    <button className="text-button" onClick={close} data-testid="success-close-button">Close this window</button>
  </div>
);
